import React from 'react';
import { LeadList } from './LeadList';

export const LeadListFactory = ({ widgetInformation }) => {
  const title = widgetInformation.config.title;
  return <LeadList title={title} />;
};
